import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Invoices',
  form: {
    title: 'Request new payment',
    company: {
      label: 'Restaurant',
    },
    billing_mode: {
      label: 'Billing source',
    },
    billing_anchor: {
      label: 'Start billing at',
    },
    items: {
      label: 'Items',
    },
    name: {
      label: 'Name',
      placeholder: '1000x Flyers',
    },
    net_amount: {
      label: 'Amount (NET)',
      tax_breakdown: '+{{tax}} VAT = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    name: 'Name/Number',
    billing_mode: 'Billing source',
    type: 'Type',
    status: 'Status',
    amount: 'Amount (Gross)',
    created_at: 'Created',
    billing_anchor: 'Billing from',
    invoice: 'Invoice',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Payment method',
    [BillingMode.InternalInvoicing]: 'Sales',
  },
  types: {
    [InvoiceType.Manual]: 'Manual',
    [InvoiceType.SetupFee]: 'Setup fee',
    [InvoiceType.Subscription]: 'Subscription',
    [InvoiceType.SubscriptionBridge]: 'Subscription (prorated to the 5th)',
    [InvoiceType.SubscriptionProration]: 'Subscription (prorated upgrade)',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'Pending',
    [InvoiceStatus.Processing]: 'Processing',
    [InvoiceStatus.Paid]: 'Paid',
    [InvoiceStatus.PartiallyRefunded]: 'Partially refunded',
    [InvoiceStatus.Refunded]: 'Refunded',
    [InvoiceStatus.Failed]: 'Failed',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Are you sure you want to create invoice for {{amount}} NET to {{company}} from {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Are you sure?',
      description:
        '<strong>{{company}}</strong> will be recharged <strong>{{amount}} gross + payment failure penalty if applicable</strong> from primary payment method for the invoice {{details}}',
      recharge_failed: {
        title: 'Stripe refused the payment',
        convert_hint:
          "You can collect this invoice from the restaurant's sales instead. The Stripe invoice will be voided and the outstanding amount will be deducted from upcoming payouts.",
      },
    },
  },
  buttons: {
    show_transfers: 'Show transfers',
    hide_transfers: 'Hide transfers',
    create: 'Create',
    download_pdf: 'Download PDF',
    open_payment_page: 'Open payment page',
    open_invoice_page: 'Open invoice details',
    add_item: 'Add item',
    convert_to_internal_billing: 'Collect from sales instead',
    recharge_invoice: 'Recharge invoice',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_create_invoice: 'Failed to create invoice!',
    invoice_got_created: 'Invoice got created!',
    invoice_got_recharged: 'Invoice got recharged. New payment is being processed!',
    failed_to_recharge_invoice: 'Failed to recharge the invoice!',
    invoice_got_converted_to_internal_billing:
      'Invoice converted to sales billing. The outstanding amount will be deducted from upcoming payouts.',
    failed_to_convert_invoice_to_internal_billing: 'Failed to convert the invoice to sales billing!',
  },
};
